<template>
  <div style='margin: 2%;'>
    <h1>OneClick - 參展單位維護</h1>
    <h4>展覽編號：{{ this.showId }}</h4>
    <div>
      <button class="btn btn-outline-success btn-block mt-1 mb-1" type="button" v-on:click="add()">
        新增參展單位
      </button>
    </div>
    <v2-table :data="boothProfileList" border :loading="loading" :default-sort='{prop: "BOOTH_NO", order: "ascending"}' @sort-change="handleSortChange" stripe>
      <v2-table-column label="攤位號碼" prop="BOOTH_NO" ></v2-table-column>
      <v2-table-column label="公司名稱" prop="COMPANY_NAME_LOCAL" ></v2-table-column>
      <v2-table-column label="統一編號" prop="UNIFORM_NUMBER" ></v2-table-column>
      <v2-table-column label="執行">
        <template slot-scope="scope">
        <button class="btn btn-outline-primary btn-sm btn-block mt-1 mb-1" type="button"
                v-on:click="edit(scope.row.SID)">編輯
        </button>
        <button class="btn btn-outline-danger btn-sm btn-block mt-1 mb-1" type="button"
                v-on:click="remove(scope.row.SID)">刪除
        </button>
        </template>
      </v2-table-column>
    </v2-table>
  </div>
</template>

<script>
export default {
  name: "AdminBoothListView",
  data: function () {
    return {
      showId: "",
      currentPage: 1,
      total: 0,
      paginationInfo: {
        text: ''
      },
      loading: false,
      boothProfileList: [],
      displayList: [],
    };
  },
  async created() {
    this.showId = this.$route.params.showId;
    this.queryBoothProfileList();
    // this.boothId = this.$route.params.boothId;
    // this.initialBoothProfile(this.$route.params.boothId);
    // await ImmortalDB.get("YSCT_FINGER_PRINT").then((key) => {
    //   if (key !== null) {
    //     this.deviceFingerPrint = key;
    //     this.queryVisitorProfile(key);
    //   } else {
    //     this.status = "NewUser";
    //     this.stage = "I";
    //   }
    // });
  },
  methods: {
    queryBoothProfileList: function () {
      const data = {
        SHOWID: this.showId,
      };
      this.$BoothAPI
        .queryBoothProfileList(data)
        .then((res) => {
          const resultStr = res.data;
          const resultObj = JSON.parse(resultStr);
          if (resultObj.statusCode === 200) {
            this.boothProfileList = resultObj.body;
            this.total = resultObj.body.length;
            this.paginationInfo.text = '<span>Total of <strong>' + resultObj.body.length + '</strong>, <strong>10</strong> per page</span>'
          } else {
            this.$alert.warningAlert(resultObj.body.MESSAGE);
          }
        })
        .catch((error) => {
          this.$alert.warningAlert(error);
          console.error(error);
        });
    },
    add: function () {

    },
    edit: function (sid) {
      alert('edit: ' + sid);
    },
    remove: function (sid) {
      alert('remove: ' + sid);
    },
    handleSortChange({prop, order}) {
      this.loading = true;
      const list = [].concat(this.boothProfileList);
      list.sort((item1, item2) => {
        const val1 = item1[prop];
        const val2 = item2[prop];
        if (order === 'descending') {
          return val2 < val1 ? -1 : 1;
        }
        return val1 < val2 ? -1 : 1;
      });
      setTimeout(() => {
        this.loading = false;
        this.boothProfileList = [].concat(list);
      }, 2000);
    },
    // handlePageChange(page) {
    //   this.currentPage = page;
    //   this.loading = true;
    //   let start = (page - 1) * 10 + 1;
    //
    //   const list = this.boothProfileList.map(item => {
    //     return Object.assign({}, item, {
    //       name: `test${start++}`
    //     });
    //   });
    //
    //   setTimeout(() => {
    //     this.loading = false;
    //     this.displayList = [].concat(list);
    //   }, 2000);
    // }
  },
};
</script>
